import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    openModalButton: {
      margin: 0,
      padding: '0.5rem 0 0 2rem',
      '&:active': {
        transform: 'none',
        boxShadow: 'none',
      },
      display: 'flex',
      gap: theme.spacing(3.25),
      flexDirection: 'row',
      justifyContent: 'start',
      width: '100%',
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      '&> *': {
        width: 'auto',
        minWidth: '4.8rem',
      },
    },
    dialogMain: {
      width: '48rem',
    },
    content: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '12rem',
    },
  }),
)
